import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-img-figma',
  templateUrl: './img-figma.component.html',
  styleUrls: ['./img-figma.component.css']
})
export class ImgFigmaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
  ) { }

  title = 'Image to Figma Plugin | Crafttor';

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Convert any image or screenshot into fully editable Figma designs. Right now it is a BETA version. Please try and let us know your feedback @ info@crafttor.com'},
      { name: 'keywords', content: 'image to figma plugin, plugin, image to figma' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);
  }
}
